import { render, staticRenderFns } from "./ShowDirectSellFactor.vue?vue&type=template&id=48e2b469&"
import script from "./ShowDirectSellFactor.vue?vue&type=script&lang=js&"
export * from "./ShowDirectSellFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports